import { InjectFlags, InjectionToken, Injector, Type } from '@angular/core';

export class RoblexInjector implements Injector {
    /**
     * Creates an instance of roblex injector.
     * @param _parentInjector Injector
     * @param _additionalTokens WeakMap<any, any>
     */
    constructor(
        public _parentInjector: Injector,
        public _additionalTokens: WeakMap<any, any>
    ) {}
    /**
     * Gets neyhaz modal injector
     * @template T
     * @param token Type<T> | InjectionToken<T>
     * @param [notFoundValue] T
     * @param [flags] InjectFlags
     * @returns T
     */
    get<T>(
        token: Type<T> | InjectionToken<T>,
        notFoundValue?: T,
        flags?: InjectFlags
    ): T;
    /**
     * Gets neyhaz modal injector
     * @param token any
     * @param [notFoundValue] any
     */
    get(token: any, notFoundValue?: any);
    /**
     * Gets neyhaz modal injector
     * @param token any
     * @param [notFoundValue] any
     * @param [flags] any
     * @returns any
     */
    get(token: any, notFoundValue?: any, flags?: any) {
        const value = this._additionalTokens.get(token);
        if (value) return value;
        return this._parentInjector.get<any>(token, notFoundValue);
    }
}
